export enum UserTypes {
  FACILITY_ADMIN = 'FACILITY_ADMIN',
  FACILITY_USER = 'FACILITY_USER',
  SUPER_ADMIN = 'SUPER_ADMIN',
  FAMILY = 'FAMILY'
}

export enum UserPermissions {
  VIEW_RESIDENTS = 'VIEW_RESIDENTS',
  EDIT_RESIDENTS = 'EDIT_RESIDENTS',
}

export const APOLLO_USER_GROUPS = Object.assign({}, UserTypes, UserPermissions);
export type APOLLO_USER_GROUPS_KEYS = keyof typeof APOLLO_USER_GROUPS;

export type userPermissions = UserPermissions | UserTypes;

export interface ApCognitoUser {
  id: string;
  username: string;
  email?: string;
  userType: UserTypes | undefined;
  permissions: userPermissions[];
}